import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

import { EuiSpacer } from '@elastic/eui';
import SuccessBox from 'components/Web_User_Interface/1440p_Series/System/Info/SuccessBox';
import PermissionBox from 'components/Web_User_Interface/1440p_Series/_permissions/SystemPerm';
import InfoTable01 from 'components/Web_User_Interface/1440p_Series/System/Info/infoTable01';
import InfoTable02 from 'components/Web_User_Interface/1440p_Series/System/Info/infoTable02';
import InfoTable03 from 'components/Web_User_Interface/1440p_Series/System/Info/infoTable03';
import BreadCrumbs from 'components/Layout/BreadCrumbs';
import SEOHelmet from 'components/Layout/SEOHelmet';
export const _frontmatter = {
  "title": "System Menü // Übersicht",
  "path": "/Web_User_Interface/1440p_Serie/System/Info/",
  "dateChanged": "2021-12-12",
  "author": "Mike Polinowski",
  "excerpt": "Info ist einfach eine Sammlung von vielen Systeminterna, die interessant sind, wenn Sie mit der Fehlersuche beginnen müssen. Dein DDNS-Zugang funktioniert nicht? Überprüfen Sie den DDNS-Status (muss erfolgreich sein) und den UPnP-Status (der wahrscheinlich deaktiviert sein muss). Sie können auch versuchen, Ihre Kamera über ihre WAN-IP (anstelle der DDNS-Adresse) zu erreichen - um zu prüfen, ob die DDNS-Adresse oder Ihre Port-Weiterleitung der Schuldige ist.",
  "image": "./WebUI_1440p_SearchThumb_System_Overview.png",
  "social": "/images/Search/WebUI_1440p_SearchThumb_System_Overview.webp",
  "toc": "/images/Search/TOC_Icons/Wiki_Tiles_WebUI_white.webp",
  "chapter": "1440p Web User Interface"
};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">



    <SEOHelmet title='System Menü // Übersicht' dateChanged='2021-12-12' author='Mike Polinowski' tag='INSTAR IP Camera' description='Info ist einfach eine Sammlung von vielen Systeminterna, die interessant sind, wenn Sie mit der Fehlersuche beginnen müssen. Dein DDNS-Zugang funktioniert nicht? Überprüfen Sie den DDNS-Status (muss erfolgreich sein) und den UPnP-Status (der wahrscheinlich deaktiviert sein muss). Sie können auch versuchen, Ihre Kamera über ihre WAN-IP (anstelle der DDNS-Adresse) zu erreichen - um zu prüfen, ob die DDNS-Adresse oder Ihre Port-Weiterleitung der Schuldige ist.' image='/images/Search/WebUI_1440p_SearchThumb_System_Language.png' twitter='/images/Search/WebUI_1440p_SearchThumb_System_Language.webp' location={props.location.pathname} mdxType="SEOHelmet" />
    <BreadCrumbs locationBC={props.location} locationDE={props.location.pathname} locationEN='/en/Web_User_Interface/1440p_Series/System/Info/' locationFR='/fr/Web_User_Interface/1440p_Series/System/Info/' crumbLabel="System Info" mdxType="BreadCrumbs" />
    <h1 {...{
      "id": "ultrahd-serien-2k-1440p--4k-2160p",
      "style": {
        "position": "relative"
      }
    }}><a parentName="h1" {...{
        "href": "#ultrahd-serien-2k-1440p--4k-2160p",
        "aria-label": "ultrahd serien 2k 1440p  4k 2160p permalink",
        "className": "header-link-icon before"
      }}><svg parentName="a" {...{
          "aria-hidden": "true",
          "focusable": "false",
          "height": "16",
          "version": "1.1",
          "viewBox": "0 0 16 16",
          "width": "16"
        }}><path parentName="svg" {...{
            "fillRule": "evenodd",
            "d": "M4 9h1v1H4c-1.5 0-3-1.69-3-3.5S2.55 3 4 3h4c1.45 0 3 1.69 3 3.5 0 1.41-.91 2.72-2 3.25V8.59c.58-.45 1-1.27 1-2.09C10 5.22 8.98 4 8 4H4c-.98 0-2 1.22-2 2.5S3 9 4 9zm9-3h-1v1h1c1 0 2 1.22 2 2.5S13.98 12 13 12H9c-.98 0-2-1.22-2-2.5 0-.83.42-1.64 1-2.09V6.25c-1.09.53-2 1.84-2 3.25C6 11.31 7.55 13 9 13h4c1.45 0 3-1.69 3-3.5S14.5 6 13 6z"
          }}></path></svg></a>{`UltraHD Serien (2K+ 1440p & 4K 2160p)`}</h1>
    <h2 {...{
      "id": "system-menü",
      "style": {
        "position": "relative"
      }
    }}><a parentName="h2" {...{
        "href": "#system-men%C3%BC",
        "aria-label": "system menü permalink",
        "className": "header-link-icon before"
      }}><svg parentName="a" {...{
          "aria-hidden": "true",
          "focusable": "false",
          "height": "16",
          "version": "1.1",
          "viewBox": "0 0 16 16",
          "width": "16"
        }}><path parentName="svg" {...{
            "fillRule": "evenodd",
            "d": "M4 9h1v1H4c-1.5 0-3-1.69-3-3.5S2.55 3 4 3h4c1.45 0 3 1.69 3 3.5 0 1.41-.91 2.72-2 3.25V8.59c.58-.45 1-1.27 1-2.09C10 5.22 8.98 4 8 4H4c-.98 0-2 1.22-2 2.5S3 9 4 9zm9-3h-1v1h1c1 0 2 1.22 2 2.5S13.98 12 13 12H9c-.98 0-2-1.22-2-2.5 0-.83.42-1.64 1-2.09V6.25c-1.09.53-2 1.84-2 3.25C6 11.31 7.55 13 9 13h4c1.45 0 3-1.69 3-3.5S14.5 6 13 6z"
          }}></path></svg></a>{`System Menü`}</h2>
    <EuiSpacer mdxType="EuiSpacer" />
    <SuccessBox mdxType="SuccessBox" />
    <EuiSpacer mdxType="EuiSpacer" />
    <PermissionBox mdxType="PermissionBox" />
    <EuiSpacer mdxType="EuiSpacer" />
    <h3 {...{
      "id": "halten-sie-ein-auge-auf-die-einstellungen-der-kamera",
      "style": {
        "position": "relative"
      }
    }}><a parentName="h3" {...{
        "href": "#halten-sie-ein-auge-auf-die-einstellungen-der-kamera",
        "aria-label": "halten sie ein auge auf die einstellungen der kamera permalink",
        "className": "header-link-icon before"
      }}><svg parentName="a" {...{
          "aria-hidden": "true",
          "focusable": "false",
          "height": "16",
          "version": "1.1",
          "viewBox": "0 0 16 16",
          "width": "16"
        }}><path parentName="svg" {...{
            "fillRule": "evenodd",
            "d": "M4 9h1v1H4c-1.5 0-3-1.69-3-3.5S2.55 3 4 3h4c1.45 0 3 1.69 3 3.5 0 1.41-.91 2.72-2 3.25V8.59c.58-.45 1-1.27 1-2.09C10 5.22 8.98 4 8 4H4c-.98 0-2 1.22-2 2.5S3 9 4 9zm9-3h-1v1h1c1 0 2 1.22 2 2.5S13.98 12 13 12H9c-.98 0-2-1.22-2-2.5 0-.83.42-1.64 1-2.09V6.25c-1.09.53-2 1.84-2 3.25C6 11.31 7.55 13 9 13h4c1.45 0 3-1.69 3-3.5S14.5 6 13 6z"
          }}></path></svg></a>{`Halten Sie ein Auge auf die Einstellungen der Kamera`}</h3>
    <p><span parentName="p" {...{
        "className": "gatsby-resp-image-wrapper",
        "style": {
          "position": "relative",
          "display": "block",
          "marginLeft": "auto",
          "marginRight": "auto",
          "maxWidth": "920px"
        }
      }}>{`
      `}<a parentName="span" {...{
          "className": "gatsby-resp-image-link",
          "href": "/de/static/f967b7fab45ca33b3a27e687ce5c17cd/abe2a/1440p_Settings_System_Info-Overview.png",
          "style": {
            "display": "block"
          },
          "target": "_blank",
          "rel": "noopener"
        }}>{`
    `}<span parentName="a" {...{
            "className": "gatsby-resp-image-background-image",
            "style": {
              "paddingBottom": "47.82608695652174%",
              "position": "relative",
              "bottom": "0",
              "left": "0",
              "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAKCAYAAAC0VX7mAAAACXBIWXMAAA7rAAAO6wFxzYGVAAACJ0lEQVQoz22Ry08TURyFW2lLSORR2sLGgglhQR9ToQgNabQYCkyh6Uxn5s6003b6IGoXLIwLYeHKuDGuDXGhJdGN/+Rn7q1BEl2c/M6cufPdc+eGspkMmZxG9eUnTt9MqF5+5fn4hmfjm7v5j17fcDj+QuPdT4zxRzYep3mUTrO5uUkos7VFNqdhXn6m9f4H7vV3nOuJkn01wbmaIK5v1Zzmt3/yb/Q//KLafksqvkQqucJaeo1QJpMhm82iH1Uwz48xzqp0vSbDrsAXBs3zY+yGjnlWxaqf4Bi6yhq1Ixyjxu62RjgUZjY8S3xh+S+wdnaO7Qgc4dJud2h5Pn6nqzLhempatsBsWphNG8O0cITH4YtDYpEosQdRkvHEFCil6zqO49Dr9hi8GjC8GtLxO9i2TbfbVQqCACEElmXdSddPWHg4TyQ8Q2o5ea9hraaAQdAnGAT4Ax/TNDEMQ0EHgwEXFxd3wOFoSLvto9dOWVpcZCb8gNTy/xr2enQ6HVpuS30ooXLKhv1+f/qu1WI0GilfqVSIRWJEI/eOrC5F11UTCQx6PXzfx/M8ms0mjUZDQSVANpSbyEz6YnGX1ZVVEvEES/OLhCRMql6vqwWypSMc5V3XVZJeSN9uIVwxfRZCNT2uVtE0jbnZOZLyH0qYbFkqlSiXyxwcHFDaL1HcKZLP5dHyGoWCxk5eo5zVKD4pUihsk8vm2Hu6x/7ePslEiuhMhI31dX4DsDdwAJjKAJgAAAAASUVORK5CYII=')",
              "backgroundSize": "cover",
              "display": "block"
            }
          }}></span>{`
  `}<picture parentName="a">{`
          `}<source parentName="picture" {...{
              "srcSet": ["/de/static/f967b7fab45ca33b3a27e687ce5c17cd/e4706/1440p_Settings_System_Info-Overview.avif 230w", "/de/static/f967b7fab45ca33b3a27e687ce5c17cd/d1af7/1440p_Settings_System_Info-Overview.avif 460w", "/de/static/f967b7fab45ca33b3a27e687ce5c17cd/7f308/1440p_Settings_System_Info-Overview.avif 920w", "/de/static/f967b7fab45ca33b3a27e687ce5c17cd/85e95/1440p_Settings_System_Info-Overview.avif 1067w"],
              "sizes": "(max-width: 920px) 100vw, 920px",
              "type": "image/avif"
            }}></source><source parentName="picture" {...{
              "srcSet": ["/de/static/f967b7fab45ca33b3a27e687ce5c17cd/a0b58/1440p_Settings_System_Info-Overview.webp 230w", "/de/static/f967b7fab45ca33b3a27e687ce5c17cd/bc10c/1440p_Settings_System_Info-Overview.webp 460w", "/de/static/f967b7fab45ca33b3a27e687ce5c17cd/966d8/1440p_Settings_System_Info-Overview.webp 920w", "/de/static/f967b7fab45ca33b3a27e687ce5c17cd/d7218/1440p_Settings_System_Info-Overview.webp 1067w"],
              "sizes": "(max-width: 920px) 100vw, 920px",
              "type": "image/webp"
            }}></source>{`
          `}<source parentName="picture" {...{
              "srcSet": ["/de/static/f967b7fab45ca33b3a27e687ce5c17cd/81c8e/1440p_Settings_System_Info-Overview.png 230w", "/de/static/f967b7fab45ca33b3a27e687ce5c17cd/08a84/1440p_Settings_System_Info-Overview.png 460w", "/de/static/f967b7fab45ca33b3a27e687ce5c17cd/c0255/1440p_Settings_System_Info-Overview.png 920w", "/de/static/f967b7fab45ca33b3a27e687ce5c17cd/abe2a/1440p_Settings_System_Info-Overview.png 1067w"],
              "sizes": "(max-width: 920px) 100vw, 920px",
              "type": "image/png"
            }}></source>{`
          `}<img parentName="picture" {...{
              "className": "gatsby-resp-image-image",
              "src": "/de/static/f967b7fab45ca33b3a27e687ce5c17cd/c0255/1440p_Settings_System_Info-Overview.png",
              "alt": "Web User Interface - 1440p Series - System Info",
              "title": "Web User Interface - 1440p Series - System Info",
              "loading": "lazy",
              "style": {
                "width": "100%",
                "height": "100%",
                "margin": "0",
                "verticalAlign": "middle",
                "position": "absolute",
                "top": "0",
                "left": "0"
              }
            }}></img>{`
        `}</picture>{`
  `}</a>{`
    `}</span></p>
    <EuiSpacer mdxType="EuiSpacer" />
    <InfoTable01 mdxType="InfoTable01" />
    <EuiSpacer mdxType="EuiSpacer" />
    <p><span parentName="p" {...{
        "className": "gatsby-resp-image-wrapper",
        "style": {
          "position": "relative",
          "display": "block",
          "marginLeft": "auto",
          "marginRight": "auto",
          "maxWidth": "920px"
        }
      }}>{`
      `}<a parentName="span" {...{
          "className": "gatsby-resp-image-link",
          "href": "/de/static/d964657935a93eb5357c3cec76472615/e4611/1440p_Settings_System_Info-Network.png",
          "style": {
            "display": "block"
          },
          "target": "_blank",
          "rel": "noopener"
        }}>{`
    `}<span parentName="a" {...{
            "className": "gatsby-resp-image-background-image",
            "style": {
              "paddingBottom": "41.30434782608695%",
              "position": "relative",
              "bottom": "0",
              "left": "0",
              "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAICAYAAAD5nd/tAAAACXBIWXMAAA7rAAAO6wFxzYGVAAABWklEQVQoz32SS08CMRSF+R/sCPPiEXENCUMiMiS6mLGdaactj4EQWWg04EZdufGHCEsT/+ExvUJCEF2c3HPb3K/nJi01Gg3U63WS77mIFu+IXz9x9bTBcL3FcL1BtPpAtNr1T1vq5dsXOuwegVdFu91BuVxGpVJBqVarEcxWz/MQXSfgagauCmRmjlTPMF7cQRdLsHxK/Y0cIzVz9PpDOE4VfhDQrOM4P0CrYHd42b9Axhm4FWMQWQopMhiVQ0lBEikHS2KE3S5c16VZK+tL+3X3wMFgAGMMdJ5BCw6jNRjn0MbAjEaQUoJzDsYYwl7vN/A4oQUKIZAWDxC3L+BCU9ppUWAymdBj9t5CwzA8DTxOqJSCnD8iXz5D6gmtLvOc0ln9C7TmEBhFEbTWUDKFEgxaK3CeIo5jJElCst4Ce6dWtsZ+HZvU933yrVYLZ6Rzqq0/1Gw2aeYQ+A3d7h1yf3QoRwAAAABJRU5ErkJggg==')",
              "backgroundSize": "cover",
              "display": "block"
            }
          }}></span>{`
  `}<picture parentName="a">{`
          `}<source parentName="picture" {...{
              "srcSet": ["/de/static/d964657935a93eb5357c3cec76472615/e4706/1440p_Settings_System_Info-Network.avif 230w", "/de/static/d964657935a93eb5357c3cec76472615/d1af7/1440p_Settings_System_Info-Network.avif 460w", "/de/static/d964657935a93eb5357c3cec76472615/7f308/1440p_Settings_System_Info-Network.avif 920w", "/de/static/d964657935a93eb5357c3cec76472615/0407b/1440p_Settings_System_Info-Network.avif 1298w"],
              "sizes": "(max-width: 920px) 100vw, 920px",
              "type": "image/avif"
            }}></source><source parentName="picture" {...{
              "srcSet": ["/de/static/d964657935a93eb5357c3cec76472615/a0b58/1440p_Settings_System_Info-Network.webp 230w", "/de/static/d964657935a93eb5357c3cec76472615/bc10c/1440p_Settings_System_Info-Network.webp 460w", "/de/static/d964657935a93eb5357c3cec76472615/966d8/1440p_Settings_System_Info-Network.webp 920w", "/de/static/d964657935a93eb5357c3cec76472615/94575/1440p_Settings_System_Info-Network.webp 1298w"],
              "sizes": "(max-width: 920px) 100vw, 920px",
              "type": "image/webp"
            }}></source>{`
          `}<source parentName="picture" {...{
              "srcSet": ["/de/static/d964657935a93eb5357c3cec76472615/81c8e/1440p_Settings_System_Info-Network.png 230w", "/de/static/d964657935a93eb5357c3cec76472615/08a84/1440p_Settings_System_Info-Network.png 460w", "/de/static/d964657935a93eb5357c3cec76472615/c0255/1440p_Settings_System_Info-Network.png 920w", "/de/static/d964657935a93eb5357c3cec76472615/e4611/1440p_Settings_System_Info-Network.png 1298w"],
              "sizes": "(max-width: 920px) 100vw, 920px",
              "type": "image/png"
            }}></source>{`
          `}<img parentName="picture" {...{
              "className": "gatsby-resp-image-image",
              "src": "/de/static/d964657935a93eb5357c3cec76472615/c0255/1440p_Settings_System_Info-Network.png",
              "alt": "Web User Interface - 1440p Series - System Info",
              "title": "Web User Interface - 1440p Series - System Info",
              "loading": "lazy",
              "style": {
                "width": "100%",
                "height": "100%",
                "margin": "0",
                "verticalAlign": "middle",
                "position": "absolute",
                "top": "0",
                "left": "0"
              }
            }}></img>{`
        `}</picture>{`
  `}</a>{`
    `}</span></p>
    <EuiSpacer mdxType="EuiSpacer" />
    <InfoTable02 mdxType="InfoTable02" />
    <EuiSpacer mdxType="EuiSpacer" />
    <p><span parentName="p" {...{
        "className": "gatsby-resp-image-wrapper",
        "style": {
          "position": "relative",
          "display": "block",
          "marginLeft": "auto",
          "marginRight": "auto",
          "maxWidth": "920px"
        }
      }}>{`
      `}<a parentName="span" {...{
          "className": "gatsby-resp-image-link",
          "href": "/de/static/b3f524b331f1ff0f8807b50317d5591a/e4611/1440p_Settings_System_Info-Downloads.png",
          "style": {
            "display": "block"
          },
          "target": "_blank",
          "rel": "noopener"
        }}>{`
    `}<span parentName="a" {...{
            "className": "gatsby-resp-image-background-image",
            "style": {
              "paddingBottom": "41.30434782608695%",
              "position": "relative",
              "bottom": "0",
              "left": "0",
              "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAICAYAAAD5nd/tAAAACXBIWXMAAA7rAAAO6wFxzYGVAAABrUlEQVQoz32SsW7TUBSG8x7ZItuJHVsxXVupjkhK3Li141zfmzgJEEKqqgMISjeWspSViRbEAKQjUgdeoAiBhBgQA0wsLEw8w4euoQipFcOv8+tI57v/0bkl13Wp1+uFalWLztYBvfuv6O4tCO8dE+4d/62d3QWd3ZdcufuC4YMTVsQt7KrB8vIK5XKZSqVCyXGcAqZrtVol3EhRkzmDq3OG17YQoylqMiMb3WA03Wa6fRs1uYkcz2i2Q0zToGbbxaxpmr+BWvaf5lq7RdQNWWtdprveIU1iepspMu0zUBkDmSH6Kf00IVhdxbKsYlZL+9LZurqhX0iShMeHR5yevuHJ4RFREiN3Zqj5dRKRE6eSOI7pC0HQbJ4HniXUMgwDJSVfPn/i54/vfHz/ljBaZ7wzZjjLkZlEKoWUEqUUQRBcDCwSOg6WaRLFCc/ffeXph28cLE6INyLGwwn5ICfP8wL2X6A2xYVtu7hyK4xo7z+j/eg1wZ2HiCRGSIkQgl6vR5qmRc2yjOZFK2ujv45OWqvV8FyXJdfmkmOx5NVp+D6NRgPf98/J87xi5l/gL+9TJtiBxzE+AAAAAElFTkSuQmCC')",
              "backgroundSize": "cover",
              "display": "block"
            }
          }}></span>{`
  `}<picture parentName="a">{`
          `}<source parentName="picture" {...{
              "srcSet": ["/de/static/b3f524b331f1ff0f8807b50317d5591a/e4706/1440p_Settings_System_Info-Downloads.avif 230w", "/de/static/b3f524b331f1ff0f8807b50317d5591a/d1af7/1440p_Settings_System_Info-Downloads.avif 460w", "/de/static/b3f524b331f1ff0f8807b50317d5591a/7f308/1440p_Settings_System_Info-Downloads.avif 920w", "/de/static/b3f524b331f1ff0f8807b50317d5591a/0407b/1440p_Settings_System_Info-Downloads.avif 1298w"],
              "sizes": "(max-width: 920px) 100vw, 920px",
              "type": "image/avif"
            }}></source><source parentName="picture" {...{
              "srcSet": ["/de/static/b3f524b331f1ff0f8807b50317d5591a/a0b58/1440p_Settings_System_Info-Downloads.webp 230w", "/de/static/b3f524b331f1ff0f8807b50317d5591a/bc10c/1440p_Settings_System_Info-Downloads.webp 460w", "/de/static/b3f524b331f1ff0f8807b50317d5591a/966d8/1440p_Settings_System_Info-Downloads.webp 920w", "/de/static/b3f524b331f1ff0f8807b50317d5591a/94575/1440p_Settings_System_Info-Downloads.webp 1298w"],
              "sizes": "(max-width: 920px) 100vw, 920px",
              "type": "image/webp"
            }}></source>{`
          `}<source parentName="picture" {...{
              "srcSet": ["/de/static/b3f524b331f1ff0f8807b50317d5591a/81c8e/1440p_Settings_System_Info-Downloads.png 230w", "/de/static/b3f524b331f1ff0f8807b50317d5591a/08a84/1440p_Settings_System_Info-Downloads.png 460w", "/de/static/b3f524b331f1ff0f8807b50317d5591a/c0255/1440p_Settings_System_Info-Downloads.png 920w", "/de/static/b3f524b331f1ff0f8807b50317d5591a/e4611/1440p_Settings_System_Info-Downloads.png 1298w"],
              "sizes": "(max-width: 920px) 100vw, 920px",
              "type": "image/png"
            }}></source>{`
          `}<img parentName="picture" {...{
              "className": "gatsby-resp-image-image",
              "src": "/de/static/b3f524b331f1ff0f8807b50317d5591a/c0255/1440p_Settings_System_Info-Downloads.png",
              "alt": "Web User Interface - 1440p Series - System Info",
              "title": "Web User Interface - 1440p Series - System Info",
              "loading": "lazy",
              "style": {
                "width": "100%",
                "height": "100%",
                "margin": "0",
                "verticalAlign": "middle",
                "position": "absolute",
                "top": "0",
                "left": "0"
              }
            }}></img>{`
        `}</picture>{`
  `}</a>{`
    `}</span></p>
    <EuiSpacer mdxType="EuiSpacer" />
    <InfoTable03 mdxType="InfoTable03" />
    <EuiSpacer mdxType="EuiSpacer" />

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      